import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  shelf: {
    flexShrink: 0,
    backgroundColor: designTokens.neutral[50],
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[8]}`,
    paddingBottom: designTokens.spacing[2],
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  inner: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  objectiveLabel: {
    display: "block",
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[800],
    fontFamily: designTokens.fontFamily,
    marginBottom: designTokens.spacing[1],
  },
  transitionMessage: {
    display: "block",
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[600],
    marginBottom: designTokens.spacing[2],
    fontFamily: designTokens.fontFamily,
    lineHeight: designTokens.lineHeight.relaxed,
  },
  introduction: {
    display: "block",
    marginBottom: designTokens.spacing[3],
  },
  currentQuestionBubble: {
    backgroundColor: designTokens.neutral.white,
    borderLeft: `4px solid ${designTokens.accent[500]}`,
    borderRadius: designTokens.borderRadius.md,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[800],
    lineHeight: designTokens.lineHeight.relaxed,
    boxShadow: designTokens.shadow.sm,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    "@media (max-width: 768px)": {
      display: "-webkit-box",
      WebkitLineClamp: "2",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      whiteSpace: "normal",
    },
  },
  optionsIntro: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: designTokens.spacing[1],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[700],
    lineHeight: designTokens.lineHeight.relaxed,
  },
  progressCounterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[3],
    marginBottom: designTokens.spacing[2],
  },
  progressCounterText: {
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.accent[600],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    whiteSpace: "nowrap",
    marginTop: designTokens.spacing[5],
  },
  optionSelectDescription:{
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[700],
    lineHeight: designTokens.lineHeight.relaxed,
    marginBottom: designTokens.spacing[4],
    marginTop: designTokens.spacing[2],
  },
  progressTrack: {
    display: "flex",
    flex: 1,
    maxWidth: "140px",
    gap: designTokens.spacing[1],
    height: "3px",
    marginTop: designTokens.spacing[5],
    
  },
  progressSegment: {
    flex: 1,
    height: "100%",
    backgroundColor: designTokens.neutral[200],
    borderRadius: designTokens.borderRadius.full,
    transition: "background-color 0.3s ease",
  },
  progressSegmentActive: {
    backgroundColor: designTokens.accent[600],
  },
});
